// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"286a531d0043f2f1de11","394":"5384b43aa1e086451e79","812":"42569750fee1bcea54f2","912":"2c541e963feac2e29a65"}[chunkId] + ".chunk.js";
};